import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

/**
 * Blocks navigation for users whose active organization is deactivated
 * (`organizationInactive`). They stay on /home with a persistent banner
 * until the org is reactivated. Super admins are exempt so they can still
 * reach organization management to reactivate the org.
 */
export const activeOrganizationGuard: CanActivateFn = () => {
  const user = inject(AuthService).currentUser();
  if (!user || user.role === 'super_admin' || !user.organizationInactive) {
    return true;
  }
  return inject(Router).parseUrl('/home');
};
